<!--
 * @Description: 详情中的支付进度
 * @Date: 2020-12-17 19:49:41
-->
<template>
  <table-render :config="config" height="52vh" />
</template>

<script>
import tableRender from '@/components/tableRender';
import { listOrderPaySchedule } from './config/index.js';
export default {
  components: { tableRender },
  name: 'listOrderPaySchedule',
  props: {
    // 父级row
    row: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // 最外层列表
    rootRow: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      config: null
    };
  },
  created() {
    let { taskDt, projectId, type } = this.rootRow;
    let { structureType, id: orderId } = this.row;
    listOrderPaySchedule[0].childMenu[0].defaultQuery = {
      taskDt,
      projectId,
      type,
      structureType,
      orderId,
      ...this.row,
      payType: this.$store.state.projectSettled.payType
    };
    this.config = listOrderPaySchedule;
  }
};
</script>

<style lang="scss" scoped>
.app-info {
  padding: 0 1.56vw;
  td {
    padding: 4px 8px;
    b {
      color: #606266;
      font-weight: 600;
    }
  }
}
</style>
